function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { selector as parseSelector } from 'vega-event-selector';
import { array, isString } from 'vega-util';
import { forEachSelection, TUPLE } from '..';
import * as log from '../../../log';
import { isLegendBinding, isLegendStreamBinding, SELECTION_ID } from '../../../selection';
import { duplicate, varName } from '../../../util';
import { TUPLE_FIELDS } from './project';
import { TOGGLE } from './toggle';
var legendBindings = {
  has: function has(selCmpt) {
    var spec = selCmpt.resolve === 'global' && selCmpt.bind && isLegendBinding(selCmpt.bind);
    var projLen = selCmpt.project.items.length === 1 && selCmpt.project.items[0].field !== SELECTION_ID;

    if (spec && !projLen) {
      log.warn(log.message.LEGEND_BINDINGS_MUST_HAVE_PROJECTION);
    }

    return spec && projLen;
  },
  parse: function parse(model, selCmpt, selDef, origDef) {
    var _a; // Binding a selection to a legend disables default direct manipulation interaction.
    // A user can choose to re-enable it by explicitly specifying triggering input events.


    if (!origDef.on) delete selCmpt.events;
    if (!origDef.clear) delete selCmpt.clear;

    if (origDef.on || origDef.clear) {
      var legendFilter = 'event.item && indexof(event.item.mark.role, "legend") < 0';

      var _iterator = _createForOfIteratorHelper(selCmpt.events),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _evt = _step.value;
          _evt.filter = array((_a = _evt.filter) !== null && _a !== void 0 ? _a : []);

          if (_evt.filter.indexOf(legendFilter) < 0) {
            _evt.filter.push(legendFilter);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var evt = isLegendStreamBinding(selCmpt.bind) ? selCmpt.bind.legend : 'click';
    var stream = isString(evt) ? parseSelector(evt, 'view') : array(evt);
    selCmpt.bind = {
      legend: {
        merge: stream
      }
    };
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var selName = selCmpt.name;
    var stream = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;

    var markName = function markName(name) {
      return function (s) {
        var ds = duplicate(s);
        ds.markname = name;
        return ds;
      };
    };

    var _iterator2 = _createForOfIteratorHelper(selCmpt.project.items),
        _step2;

    try {
      var _loop = function _loop() {
        var proj = _step2.value;
        if (!proj.hasLegend) return "continue";
        var prefix = "".concat(varName(proj.field), "_legend");
        var sgName = "".concat(selName, "_").concat(prefix);
        var hasSignal = signals.filter(function (s) {
          return s.name === sgName;
        });

        if (hasSignal.length === 0) {
          var events = stream.merge.map(markName("".concat(prefix, "_symbols"))).concat(stream.merge.map(markName("".concat(prefix, "_labels")))).concat(stream.merge.map(markName("".concat(prefix, "_entries"))));
          signals.unshift(Object.assign(Object.assign({
            name: sgName
          }, !selCmpt.init ? {
            value: null
          } : {}), {
            on: [// Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
            {
              events: events,
              update: 'datum.value || item().items[0].items[0].datum.value',
              force: true
            }, {
              events: stream.merge,
              update: "!event.item || !datum ? null : ".concat(sgName),
              force: true
            }]
          }));
        }
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;

    var tuple = _signals.find(function (s) {
      return s.name === name + TUPLE;
    });

    var fields = name + TUPLE_FIELDS;
    var values = proj.items.filter(function (p) {
      return p.hasLegend;
    }).map(function (p) {
      return varName("".concat(name, "_").concat(varName(p.field), "_legend"));
    });
    var valid = values.map(function (v) {
      return "".concat(v, " !== null");
    }).join(' && ');
    var update = "".concat(valid, " ? {fields: ").concat(fields, ", values: [").concat(values.join(', '), "]} : null");

    if (selCmpt.events && values.length > 0) {
      tuple.on.push({
        events: values.map(function (signal) {
          return {
            signal: signal
          };
        }),
        update: update
      });
    } else if (values.length > 0) {
      tuple.update = update;
      delete tuple.value;
      delete tuple.on;
    }

    var toggle = _signals.find(function (s) {
      return s.name === name + TOGGLE;
    });

    var events = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;

    if (toggle) {
      if (!selCmpt.events) toggle.on[0].events = events;else toggle.on.push(Object.assign(Object.assign({}, toggle.on[0]), {
        events: events
      }));
    }

    return _signals;
  }
};
export default legendBindings;
export function parseInteractiveLegend(model, channel, legendCmpt) {
  var _a;

  var field = (_a = model.fieldDef(channel)) === null || _a === void 0 ? void 0 : _a.field;
  forEachSelection(model, function (selCmpt) {
    var _a, _b;

    var proj = (_a = selCmpt.project.hasField[field]) !== null && _a !== void 0 ? _a : selCmpt.project.hasChannel[channel];

    if (proj && legendBindings.has(selCmpt)) {
      var legendSelections = (_b = legendCmpt.get('selections')) !== null && _b !== void 0 ? _b : [];
      legendSelections.push(selCmpt.name);
      legendCmpt.set('selections', legendSelections, false);
      proj.hasLegend = true;
    }
  });
}